import React from 'react';
import { FaUsers, FaUserCheck, FaUserClock, FaStore, FaBan } from 'react-icons/fa';
import '../../../assets/css/admin/adminUsersManagement/userstatscards.css';

const UserStatsCards = ({ stats = {}, role }) => {
  const getCardsConfig = () => {
    if (role === 'admins') {
      return [
        { id: 1, title: 'Total Admins', value: stats.totaladmins || 0, icon: FaUsers, colorClass: 'usc-primary', iconClass: 'usc-icon-primary' },
        { id: 2, title: 'Active Admins', value: stats.active || 0, icon: FaUserCheck, colorClass: 'usc-success', iconClass: 'usc-icon-success' },
        { id: 3, title: 'Inactive Admins', value: stats.inactive || 0, icon: FaUserClock, colorClass: 'usc-secondary', iconClass: 'usc-icon-secondary' },
      ];
    }
    if (role === 'customers') {
      return [
        { id: 1, title: 'Total Customers', value: stats.total || 0, icon: FaUsers, colorClass: 'usc-primary', iconClass: 'usc-icon-primary' },
        { id: 2, title: 'Active Customers', value: stats.active || 0, icon: FaUserCheck, colorClass: 'usc-success', iconClass: 'usc-icon-success' },
      ];
    }
    return [
      { id: 1, title: 'Total Vendors', value: stats.total || 0, icon: FaStore, colorClass: 'usc-primary', iconClass: 'usc-icon-primary' },
      { id: 2, title: 'Active Vendors', value: stats.active || 0, icon: FaUserCheck, colorClass: 'usc-success', iconClass: 'usc-icon-success' },
      { id: 3, title: 'Pending Vendors', value: stats.pending || 0, icon: FaUserClock, colorClass: 'usc-warning', iconClass: 'usc-icon-warning' },
    ];
  };

  const cards = getCardsConfig();

  return (
    <div className={`usc-container usc-cols-${cards.length}`}>
      {cards.map((card) => {
        const IconComponent = card.icon;
        return (
          <div key={card.id} className={`usc-card ${card.colorClass}`}>
            <div className="usc-card-body">
              <div className="usc-info">
                <p className="usc-title">{card.title}</p>
                <h2 className="usc-value">{card.value}</h2>
              </div>
              <div className={`usc-icon-wrap ${card.iconClass}`}>
                <IconComponent />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserStatsCards;